import es from './es';
import en from './en';

export const locales = { en, es };
